import { render, staticRenderFns } from "./TabComponent.vue?vue&type=template&id=4d42e3ed&scoped=true"
import script from "./TabComponent.vue?vue&type=script&lang=js"
export * from "./TabComponent.vue?vue&type=script&lang=js"
import style0 from "./TabComponent.vue?vue&type=style&index=0&id=4d42e3ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d42e3ed",
  null
  
)

export default component.exports